<template>
  <div class="mini-calendar__pager">
    <v-pagination
    v-model="page"
    :pages="getPages"
    :range-size="1"
    active-color="#DCEDFF"
    @update:modelValue="updateHandler"
    v-if="getPages > 1"
  />
  </div>
</template>

<script>
import { DEFAULT_LIMIT } from "@/utils/config"
import { mapGetters, mapActions } from 'vuex'
import { search, getFilteredEvents } from './../api'
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
  name: 'MiniCalenderPager',
  components: {
    VPagination
  },
  props: {
    scroll: {
      type: Function,
      required: true
    }
  },
  date() {
    return {
        page_size: DEFAULT_LIMIT,
    }
  },
  methods: {
    updateHandler(page) {
        this.scroll();
        this.setLoading(true);
        this.setPage(page);

        if (this.search) {
            search(this.search, page).then((result) => {
                this.setEventList({eventlist: result.data, total: result.query.total});
                this.setLoading(false);
            }).catch(() => {
                this.setLoading(false);
            });
        } else {
            getFilteredEvents(this.date_range.start, this.date_range.end, this.filter, page).then((response) => {
                if (response) {
                    let data = response.data ? response.data : [];
                    this.setEventList({eventlist: data, total: response.query.total})
                }
                this.setLoading(false);
            }).catch(()=> {
                this.setLoading(false);
            });
        }

    },
    // onClear() {

    //   this.setLoading(true);
    //   getEvents().then((eventlist) => {
    //     this.setClearAll();
    //     this.setEventList({eventlist: eventlist.data, total: eventlist.total})
    //     this.setLoading(false);
    //   }).catch(() => {
    //     this.setLoading(false);
    //   });
    // },
    ...mapActions(['setEventList', 'setLoading', 'setPage'])
  },
  computed: {
    getPages() {
        return Math.ceil(this.total / DEFAULT_LIMIT);
    },
    ...mapGetters(['total', 'page', 'search', 'date_range', 'filter'])
  }
}
</script>
<style lang="scss">
.mini-calendar__pager {
    padding: rem(20);
    display: flex;
    justify-content: center;

    .Page {
        width: rem(40);
        height: rem(40);
        border-radius: 0;
        font-size: 1rem;

        &-active {
            background: $background-color;
            border-color: $border-color1;
        }
    }
}
</style>